import { format } from "date-fns";

// Shared ISO `yyyy-mm-dd` <-> `Date` helpers used by both the date-leg input
// and the seed defaults computed during kind transitions. The conversion pair
// lives with the date parameter module since it defines the same wire format.
export { formatIsoDate, parseIsoDate } from "~/pages/Reporting/dateParameters/isoDate";

/** Today as `yyyy-mm-dd` in the user's local timezone. Used as the date-mode
 * fallback when seeding a CUSTOM date leg with no parameter options. */
export const todayIsoDate = (): string => format(new Date(), "yyyy-MM-dd");
